import { createSelector } from 'reselect';

const selectGlobalPinCodes = (state: any) => state.globalPinCodes;


export const selectGlobalPinCodesCurrentItem = createSelector([selectGlobalPinCodes], (globalPinCodes) => globalPinCodes.current);

export const selectGlobalPinCodesListItems = createSelector([selectGlobalPinCodes], (globalPinCodes) => globalPinCodes.list);

export const selectGlobalPinCodesItemById = (itemId: any) =>
    createSelector(selectGlobalPinCodesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectGlobalPinCodesQueryItems = createSelector([selectGlobalPinCodes], (globalPinCodes) => globalPinCodes.query);

export const selectGlobalPinCodesCreatedItem = createSelector([selectGlobalPinCodes], (globalPinCodes) => globalPinCodes.create);

export const selectGlobalPinCodesUpdatedItem = createSelector([selectGlobalPinCodes], (globalPinCodes) => globalPinCodes.update);

export const selectGlobalPinCodesReadItem = createSelector([selectGlobalPinCodes], (globalPinCodes) => globalPinCodes.read);

export const selectGlobalPinCodesDeletedItem = createSelector([selectGlobalPinCodes], (globalPinCodes) => globalPinCodes.delete);

export const selectGlobalPinCodesSearchedItems = createSelector([selectGlobalPinCodes], (globalPinCodes) => globalPinCodes.search);

export const selectGlobalPinCodesItemsCount = createSelector([selectGlobalPinCodes], (globalPinCodes) => globalPinCodes.count);

export const selectGlobalPinCodesItemsFilter = createSelector([selectGlobalPinCodes], (globalPinCodes) => globalPinCodes.filter);